import Button from "@app/components/move2Library/Button/Button"
import { useCustomNavigation, useNavigationData } from "@app/components/navigation/NavigationHandler"
import { useGetFunnel, useGetPlanningObject } from "@app/store/service/connectorService"
import { classNamez } from "@tecreation/funnel-components"
import { useEffect, useState } from "react"
import { TabletImmersiveRoomBase } from "../TabletImmersiveRoomBase"

export default function TabletImmersiveRoomBooking1() {
	const { data: objects, refetch } = useGetPlanningObject({ date: new Date().toISOString().slice(0, 10) })
	const { push } = useCustomNavigation()
	const { data } = useGetFunnel()
	const navData = useNavigationData()
	const [option, setOption] = useState(navData?.option)

	useEffect(() => {
		refetch()
		let timer = setInterval(() => {
			refetch()
		}, 10000)

		return () => clearTimeout(timer)
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [])

	return (
		<TabletImmersiveRoomBase>
			{/* <Loader show={isFetching} /> */}
			<div className="f3">Buchen Sie sich hier einen kostenfreien Platz für den {data?.funnel}.</div>
			<div className="f4 mt-4">Zu welcher Uhrzeit möchten Sie Plätze im {data?.funnel} reservieren?</div>

			<div className="flex mt-5 flex-wrap" style={{ justifyContent: "left" }}>
				{objects && (objects.length === 0 || objects.reduce((count, next) => count + next.restCount, 0) <= 0) && (
					<div className="color-fg-danger semibold">Für den heutigen Tag sind keine freien Kapazitäten verfügbar ☹</div>
				)}
				{objects &&
					objects.map(entry => {
						if (entry.restCount <= 0) return

						return (
							<div
								key={entry.timeBlockPlanningId}
								className={
									"border rounded-3 py-2 px-4 mr-4 text-center mt-3" +
									classNamez({
										"color-bg-primary": entry.timeBlockPlanningId === option?.timeBlockPlanningId,
										"color-fg-white": entry.timeBlockPlanningId === option?.timeBlockPlanningId,
									})
								}
								style={{ width: "130px" }}
								onClick={() => {
									if (entry.timeBlockPlanningId === option?.timeBlockPlanningId) {
										setOption(undefined)
									} else {
										setOption(entry)
									}
								}}
							>
								<div>{entry.timeFrom.slice(0, 5)}</div>
								<div>Plätze: {entry.restCount}</div>
							</div>
						)
					})}
			</div>
			<div className="mt-auto flex">
				<Button
					style="secondary"
					className="ml-auto"
					disabled={!option}
					onClick={() => {
						push("/tablet-immersive-room-2", undefined, { option })
					}}
				>
					Weiter
				</Button>
			</div>
		</TabletImmersiveRoomBase>
	)
}
